<template>
  <content-layout class="modal">
    <div class="result">
      <div class="top">
        <div class="title">{{ error.title }}</div>
        <p class="message">{{ error.text }}</p>
      </div>
      <div class="bottom">
        <button v-if="errorCode !== 2" type="button" class="btn confirm" @click="tryAgain">Вернуться к оплате</button>
        <div class="contact">
          <div class="support">служба поддержки</div>
          <div class="contact-links">
            <a href="mailto:goldapple@goldapple.ru" target="_blank">goldapple@goldapple.ru</a>
          </div>
        </div>
      </div>
      <router-link :to="{ name: 'Index' }" class="go-back content-box-component"></router-link>
    </div>
  </content-layout>
</template>

<script>
import ContentLayout from '@/components/ContentLayout.vue'

export default {
  name: 'modal-error',
  data () {
    return {
      title: '',
      text: ''
    }
  },
  components: {
    ContentLayout: ContentLayout
  },
  computed: {
    errorCode () {
      return parseInt(this.$route.query.code, 10)
    },
    error () {
      switch (this.errorCode) {
        case 1: return {
          title: 'Ошибка платежного шлюза',
          text: 'Данные вашего заказа были сохранены. Попробуйте еще раз. При повторяющейся ошибке, пожалуйста, свяжитесь с службой поддержки вашего банка.'
        }
        case 2: return {
          title: 'Ошибка активации',
          text: 'Ваша подарочная карта уже была активирована или не найдена в системе заказов. Пожалуйста, свяжитесь со службой поддержки.'
        }
        default: return {
          title: 'кажется что-то пошло не так',
          text: 'Данные вашего заказа были сохранены. Попробуйте еще раз. При повторяющейся ошибке, пожалуйста, свяжитесь с службой поддержки.'
        }
      }
    }
  },
  methods: {
    tryAgain () {
      const order = this.$localStorage.get('order')
      const routeName = order
        ? order.type === 'real'
          ? 'RealCards'
          : 'VirtualCards'
        : 'Index'
      this.$router.push({ name: routeName })
    }
  },
  created () {
    this.order = this.$localStorage.set('result', 'error')
  }
}
</script>

<style scoped>
  .result {
    position: relative;
    font: 500 14px/1 Museo, sans-serif;
    width: 460px;
  }
  .top {
    padding: 30px 33px 70px;
    border-bottom: 1px solid rgba(139, 139, 139, .5);
  }
  .go-back {
    position: absolute;
    top: -5px;
    right: 20px;
    width: 20px;
    height: 20px;
    text-indent: 100%;
    white-space: nowrap;
    overflow: hidden;
    padding: 5px;
    opacity: .4;
  }
  .go-back:hover {
    opacity: 1;
  }
  .go-back::before,
  .go-back::after {
    content: '';
    display: block;
    background: #000;
    height: 3px;
    width: 25px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    transform-origin: center;
  }
  .go-back::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
  .title {
    font: 700 60px Bebas, sans-serif;
    line-height: 50px;
    margin-bottom: 10px;
  }
  .message {
    color: rgba(0, 0, 0, .8);
    font-size: 18px;
    line-height: normal;
    margin: 0;
  }
  .bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 33px 30px;
    background-color: #ededed;
    box-shadow: inset 0 4px 12px 0 rgba(0, 0, 0, 0.05);
  }
  .confirm {
    width: 360px;
    border-radius: 4px;
    text-transform: uppercase;
    line-height: 56px;
    font-size: 15px;
    font-weight: bold;
  }
  .confirm {
    background: #bc9665;
    color: #fff;
    margin-bottom: 15px;
  }
  .confirm:hover,
  .confirm:focus {
    background-color: #b68b55;
  }
  .contact {
    color: rgba(0, 0, 0, .3);
    text-align: center;
    font-weight: 700;
  }
  .support {
    font-size: 11px;
    text-transform: uppercase;
    margin-bottom: 3px;
  }

  /*=============================================>>>>>
  = Mobile =
  ===============================================>>>>>*/

  @media screen and (max-width: 1023px) {

    .result {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    .top {
      background-color: #f6f6f7;
      border: none;
      padding: 0 20px 25px;
    }
    .go-back {
      background-color: #fff;
      box-shadow: 2.8px 2.8px 14px 0 rgba(0, 0, 0, 0.15);
      border-radius: 50%;
      overflow: hidden;
      padding: 17px;
      position: fixed;
      z-index: 2;
      top: 12px;
      right: 8px;
      opacity: .7;
    }
    .go-back::before,
    .go-back::after {
      width: 20px;
    }
    .title {
      font-size: 60px;
      margin-bottom: 5px;
    }
    .bottom {
      margin-top: auto;
      padding: 36px 33px;
    }
    .confirm {
      width: 100%;
      max-width: 330px;
      font-size: 14px;
      line-height: 48px;
    }
    .contact {
      color: rgba(0, 0, 0, .6);
    }
    .support {
      font-size: 12px;
    }
  }
</style>
